module.exports = __webpack_public_path__ + "static/media/In-Person.8735bf1b.svg";